import { useTheme } from 'styled-components';

import PaginationNextArrowSvg from '@/shared/assets/icons/ui-kit/pagination-next-arrow.svg';
import { Box } from '@/shared/ui/box';
import { Icon } from '@/shared/ui/icon';
import { Text } from '@/shared/ui/text';

import * as Styled from './page-wrapper.styles';
import { PageWrapperProps } from './page-wrapper.types';

const PageWrapperComponent = ({
	children,
	wrapper = false,
	breadcrumbs = false,
	paragraph = '0',
	overflow = 'auto',
	title = '',
	paragraphTitle = '32px',
	headerAction,
	footerAction,
}: PageWrapperProps) => {
	const {
		text: {
			colors: { secondary },
		},
	} = useTheme();
	const hasFooter = footerAction;

	return (
		<Styled.Wrapper>
			<Styled.ScrollableContent paragraph={paragraph} overflow={overflow}>
				{breadcrumbs && (
					<Styled.PageBreadCrumbs paragraph="20px" items={Array.isArray(breadcrumbs) ? breadcrumbs : undefined} />
				)}
				{title &&
					(headerAction ? (
						<Box align="center" justify="space-between" marginBottom={paragraphTitle} gap={16}>
							<Styled.PageHeaderTitle label={title} />
							{headerAction}
						</Box>
					) : (
						<Styled.PageTitle label={title} paragraph={paragraphTitle} />
					))}
				{wrapper ? (
					<Styled.InnerWrapper direction="column" padding="24px">
						{children}
					</Styled.InnerWrapper>
				) : (
					children
				)}
			</Styled.ScrollableContent>
			{hasFooter && (
				<Styled.FooterAction onClick={footerAction.onClick} align="center" justify="end" gap={12} cursor="pointer">
					<Text label={footerAction.label} cursor="pointer" color="secondary" />
					<Icon Svg={PaginationNextArrowSvg} fill={secondary} />
				</Styled.FooterAction>
			)}
		</Styled.Wrapper>
	);
};

export default PageWrapperComponent;
